import Header from './Header';
import Footer from './Footer';
import SearchOverlay from './SearchOverlay';
import PageLoader from './PageLoader';
import CookieConsent from './CookieConsent';
import SideMenu from './SideMenu';
import { SearchProvider } from '../contexts/SearchContext';

function Layout({ children }) {
  return (
    <SearchProvider>
      {/* Scroll to top arrow */}
      <a className="scroll-top-arrow" href="/" onClick={(e) => e.preventDefault()}>
        <i className="fa fa-angle-up"></i>
      </a>

      {/* Page Loader - Reusable Component */}
      <PageLoader />

      {/* Header component */}
      <Header />

      {/* Page content (passed as children) */}
      {children}

      {/* Footer component */}
      <Footer />

      {/* Search overlay component */}
      <SearchOverlay />

      {/* Mobile Side Menu */}
      <SideMenu />

      {/* Cookie Consent Banner */}
      <CookieConsent />
    </SearchProvider>
  );
}

export default Layout;
